import { camelCase } from 'lodash-es';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import * as IBooks from '../../../../../interfaces/merchants/resources/books';
import BooksLabel from '../../../../../molecules/merchant/resources/book/common/labels/BooksLabel';

import css from './PaymentText.module.scss';
import { CardBrandList } from '../../../../../molecules/common/CardBrandList';
import { useSelector, shallowEqual } from 'react-redux';
import { ReduxState } from '../../../../../redux/reducers';
import { getMerchantResourcesBooks } from '../../../../../redux/selectors/merchants/resources/books';

interface Props {
  payment: IBooks.PaymentMethod;
}

const PaymentText = ({ payment }: Props) => {
  const intl = useIntl();
  const errors = payment.disabled_reasons
    ? payment.disabled_reasons.filter(
        (r) =>
          r !== IBooks.DisabledReason.NoProducts &&
          r !== IBooks.DisabledReason.LimitExceeded,
      )
    : [];
  const merchantResourcesBooksState = useSelector(
    (state: ReduxState) => getMerchantResourcesBooks(state),
    shallowEqual,
  );

  // REFACTOR: 下位のコンポーネントまで具体的なmethodでの分岐をしているのが良くない。
  // 上位でレンダリングする構造を作ってしまって、あとはpropsで落ちていくだけにしたほうが良い
  if (payment.method === 'credit_card') {
    return (
      <>
        <span>
          {intl.formatMessage({ id: 'books.paymentMethod.creditCard' })}
          <span className={css.ml_10px}>
            <BooksLabel
              label={intl.formatMessage({
                id: 'books.paymentMethod.prepayment',
              })}
            />
          </span>
          <div className={css.mt_8px}>
            <CardBrandList
              isJCBEnabled={merchantResourcesBooksState.jcbEnabled}
            />
          </div>
        </span>
        <span className={css.price}>
          <FormattedMessage
            id="books.paymentMethod.price"
            values={{ price: payment.price }}
          />
        </span>
      </>
    );
  } else if (
    payment.method === 'onsite' ||
    payment.method === 'bank_transfer'
  ) {
    return (
      <>
        <span>
          {intl.formatMessage({
            id: `books.paymentMethod.${camelCase(payment.method)}`,
          })}
        </span>
        <span className={css.price}>
          {!!payment.price && (
            <FormattedMessage
              id="books.paymentMethod.price"
              values={{ price: payment.price }}
            />
          )}
        </span>
      </>
    );
  } else if (payment.method === 'subscription') {
    return (
      <>
        {errors.length > 0 ? (
          <span className={css.disabled}>
            {`${intl.formatMessage({
              id: 'books.paymentMethod.subscription',
            })} (${intl.formatMessage({
              id: `books.paymentMethod.${errors[0]}`,
            })})`}
          </span>
        ) : (
          <span>
            {intl.formatMessage({ id: 'books.paymentMethod.subscription' })}
          </span>
        )}
      </>
    );
  } else if (payment.method === 'ticket') {
    return (
      <>
        {errors.length > 0 ? (
          <span className={css.disabled}>
            {`${intl.formatMessage({
              id: 'books.paymentMethod.ticket',
            })} (${intl.formatMessage({
              id: `books.paymentMethod.${errors[0]}`,
            })})`}
          </span>
        ) : (
          <span>
            {intl.formatMessage({ id: 'books.paymentMethod.ticket' })}
          </span>
        )}
      </>
    );
  }
  return null;
};

export default PaymentText;
